export default __webpack_public_path__ + "static/small2@2x-eb198318a592a714696c9adf37e68c0b.jpg";